import { Image } from 'components/image';
import { useTranslations } from 'next-intl';
import { CatHeading } from 'components/blocks-components';
import styles from '../../customer-account.module.scss';
import { SelectEquipmentButton } from './select-equipment-button';
import { NO_EQUIPMENT_IMAGE } from '../../constants';
import { NoActiveEquipmentMobileProps } from '../../types';

export const NoActiveEquipmentMobile = ({
  hasEquipments = false
}: Readonly<NoActiveEquipmentMobileProps>) => {
  const { src, alt } = NO_EQUIPMENT_IMAGE;
  const t = useTranslations();
  return (
    <div className={styles['my-equipment--selected-equipment-wrapper']}>
      <div className="row p-3 p-md-4 g-0">
        <div className="col-md-6 order-md-2 d-flex justify-content-center">
          <div className={`${styles['no-equipment-image']}`}>
            <Image src={src} alt={alt} fill />
          </div>
        </div>
        <div className="col-md-6 order-md-1 pe-md-3">
          <CatHeading variant="headline">
            <span className="u-color--Black">{t('SHOP_CAT_PARTS_FIT')}</span>
          </CatHeading>
          <CatHeading variant="body-sm">
            <span className="pb-3 mb-md-4 pb-md-1 pt-1 d-inline-block u-color--Black ">
              {t('MOB_NO_EQP_MSG')}
            </span>
          </CatHeading>
          <SelectEquipmentButton hasEquipments={hasEquipments} />
        </div>
      </div>
    </div>
  );
};
